import _implicitStylesheets from "./resourceEmptySpace.css";
import _implicitScopedStylesheets from "./resourceEmptySpace.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="slds-grid slds-grid_align-center empty-space-container${0}"${2}><img${"a1:src"} class="slds-size_1-of-2${0}"${"a1:alt"}${2}><div class="slds-grid slds-size_1-of-2 slds-grid_vertical-align-center empty-space-description${0}"${2}>${"t3"}</div></div>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment} = $api;
  return [api_static_fragment($fragment1, 1, [api_static_part(1, {
    attrs: {
      "src": $cmp.images.goat,
      "alt": $cmp.label
    }
  }, null), api_static_part(3, null, api_dynamic_text($cmp.label))])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-42g69dtb4tp";
tmpl.legacyStylesheetToken = "appx-emptySpace_resourceEmptySpace";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
